// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kuDy4","comment":"styles_comment__2iCnZ"};